import React, { useEffect, memo } from "react";
import { connect } from "react-redux";
import { createSelector } from "reselect";

import Place from "../../../../components/SpaceContent/Place";
import Empty from "../../../../components/SpaceContent/Empty";
import SlideMenu from "../../../../components/SlideMenu";
import PLaylistSongs from "./PlaylistSongs";
import VideolistVideos from "./VideolistVideos";
import { loadAvmapBindings } from "../../../../store/ContentPlaylists/actions";
import PlaylistHeader from "./PlaylistSongs/PlaylistHeader";

function truncateString(str) {
  if (str.length > 28) {
    return str.substring(0, 25) + "...";
  }
  return str;
}

// Упрощенные селекторы
const selectCurrentVideolist = (state) => {
  const selected = state.videolists.selected[0];
  return selected
    ? state.videolists.allVideolists.find((cur) => cur.id === selected)
    : undefined;
};

const selectIsMusicMode = (state) =>
  state.collapsible.collapsibleName === "music";

const Where = memo(
  ({ currentVideolist, isMusikColapsable, loadAvmapBindings }) => {
    useEffect(() => {
      loadAvmapBindings();
    }, [loadAvmapBindings]);


    return (
      <>
        {isMusikColapsable ? (
          <Place number={2} className="ObjectsWhere">
            <PlaylistHeader />
            <SlideMenu
              activeItem={1}
              items={[
                {
                  title: "Настройки Плейлиста",
                  content: <PLaylistSongs key={6} placeNumber={1} />,
                },
              ]}
            />
          </Place>
        ) : (
          <Place number={2} className="ObjectsWhere">
            {!currentVideolist && (
              <Empty
                style={{
                  minHeight: "154px",
                  paddingTop: 18,
                }}
              >
                Выберите видео-список
              </Empty>
            )}
            <SlideMenu
              activeItem={1}
              items={[
                {
                  title: "Настройки видеолиста",
                  content: <VideolistVideos placeNumber={2} active />,
                },
              ]}
            />
          </Place>
        )}
      </>
    );
  }
);

const mapStateToProps = createSelector(
  [selectCurrentVideolist, selectIsMusicMode],
  (currentVideolist, isMusikColapsable) => ({
    currentVideolist,
    isMusikColapsable,
  })
);

export default connect(mapStateToProps, { loadAvmapBindings })(Where);
